/*
 * tryon-face-fit.js — single source of truth for face-fit frame sizing.
 *
 * Both entry points call this so frames are sized identically:
 *   - product-page modal   → assets/virtual-try-on.js
 *   - standalone /pages/try-on → sections/try-on.liquid (inline script)
 *
 * The frame PNG is drawn INTO a canvas whose pixel dimensions (w/h) equal the
 * video's intrinsic resolution, so the frame shares the video's coordinate
 * space. Whatever CSS scaling the browser applies to the <video> is applied
 * equally to the overlay <canvas>, so the frame stays correctly sized on the
 * face at any display size or aspect ratio.
 */
(function () {
  // ctx        : 2D context of the overlay canvas
  // w, h       : canvas pixel dims — MUST equal video.videoWidth/videoHeight
  // landmarks  : MediaPipe normalized (0-1) face landmarks
  // frameImg   : loaded frame PNG (Image)
  // opts       : { widthMul=1.8, vShift=0.03, prevFrameImg, alpha } (crossfade optional)
  function drawFrameAtLandmarks(ctx, w, h, landmarks, frameImg, opts) {
    if (!frameImg || !frameImg.complete || frameImg.naturalWidth === 0) return;
    if (!landmarks || landmarks.length === 0) return;
    opts = opts || {};
    var widthMul = opts.widthMul == null ? 1.8 : opts.widthMul;
    var vShift = opts.vShift == null ? 0.03 : opts.vShift;

    // 33 = right eye outer corner, 263 = left eye outer corner
    var le = landmarks[33], re = landmarks[263];
    var lx = le.x * w, ly = le.y * h;
    var rx = re.x * w, ry = re.y * h;

    var cx = (lx + rx) / 2;
    var cy = (ly + ry) / 2;
    var dist = Math.sqrt((rx - lx) * (rx - lx) + (ry - ly) * (ry - ly));
    var angle = Math.atan2(ry - ly, rx - lx);

    cy += dist * vShift; // drop slightly so frames sit on the nose bridge

    var fw = dist * widthMul;
    var fh = fw * frameImg.naturalHeight / frameImg.naturalWidth;

    ctx.save();
    ctx.translate(cx, cy);
    ctx.rotate(angle);

    var pf = opts.prevFrameImg;
    var a = opts.alpha;
    if (pf && pf.complete && pf.naturalWidth && a != null && a < 1) {
      var pfh = fw * pf.naturalHeight / pf.naturalWidth;
      ctx.globalAlpha = 1 - a;
      ctx.drawImage(pf, -fw / 2, -pfh / 2, fw, pfh);
      ctx.globalAlpha = a;
      ctx.drawImage(frameImg, -fw / 2, -fh / 2, fw, fh);
      ctx.globalAlpha = 1;
    } else {
      ctx.drawImage(frameImg, -fw / 2, -fh / 2, fw, fh);
    }

    ctx.restore();
  }

  window.TryOnFaceFit = { drawFrameAtLandmarks: drawFrameAtLandmarks };
})();
